module.exports = "https://cwa.roocdn.com/_next/static/grey.edef4e59.svg";